import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="integrations-setup"
export default class extends Controller {
  static targets = ["apiKeyField", "integrationNameField", "saveButton"]

  connect() {
    console.log("IntegrationsSetup controller connected")
    console.log("API key fields found:", this.apiKeyFieldTargets.length)
    console.log("Save button found:", this.hasSaveButtonTarget)
    
    // Set initial state
    this.updateIntegrationFields()
  }

  // Called when any API key field changes
  updateIntegrationFields() {
    let hasAnyApiKey = false
    
    this.apiKeyFieldTargets.forEach(field => {
      const platform = field.dataset.platform
      const hasValue = field.value.trim().length > 0
      
      console.log(`Platform ${platform}: hasValue = ${hasValue}, value = "${field.value}"`)
      
      // Find the corresponding integration name field
      const nameField = this.integrationNameFieldTargets.find(nf => 
        nf.dataset.platform === platform
      )
      
      if (nameField) {
        nameField.style.display = hasValue ? 'block' : 'none'
      }
      
      if (hasValue) {
        hasAnyApiKey = true
      }
    })
    
    console.log('Has any API key:', hasAnyApiKey)
    
    // Enable/disable save button
    if (this.hasSaveButtonTarget) {
      this.saveButtonTarget.disabled = !hasAnyApiKey
      console.log('Save button disabled:', this.saveButtonTarget.disabled)
      
      // Update visual state
      if (hasAnyApiKey) {
        this.saveButtonTarget.classList.remove('opacity-50', 'cursor-not-allowed')
        this.saveButtonTarget.classList.add('hover:shadow-xl')
      } else {
        this.saveButtonTarget.classList.add('opacity-50', 'cursor-not-allowed')
        this.saveButtonTarget.classList.remove('hover:shadow-xl')
      }
    } else {
      console.log('Save button target not found!')
    }
  }

  // Action method called on input events
  apiKeyChanged() {
    this.updateIntegrationFields()
  }
}
